<template>
  <div class="carousel-container">

    <!-- 加载状态 -->
    <div v-if="loading" class="carousel-loading">
      <div class="loading-spinner"></div>
      <p>加载轮播图中...</p>
    </div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="carousel-error">
      <p>{{ error }}</p>
      <button class="btn-primary" @click="fetchBanners">重试</button>
    </div>

    <!-- 轮播图内容 -->
    <div v-else>
      <div class="carousel-slides-container">
        <div
          v-for="(banner, index) in banners"
          :key="banner.id"
          class="carousel-slide"
          :class="{ active: currentSlide === index }"
          :style="{ backgroundImage: `url(${BASE_URL + banner.imageUrl})` }"
          @click="handleBannerClick(banner)"
        >
          <div class="carousel-content">
            <h2 class="carousel-title" v-html="formatText(banner.levelOneTitle)"></h2>
            <h3 v-if="banner.levelTwoTitle" class="carousel-subtitle" v-html="formatText(banner.levelTwoTitle)"></h3>
            <p v-if="banner.description" class="carousel-description" v-html="formatText(banner.description)"></p>
          </div>
        </div>
      </div>
      <div v-if="banners.length > 0" class="carousel-indicators">
        <div
          v-for="(banner, index) in banners"
          :key="banner.id"
          class="indicator"
          :class="{ active: currentSlide === index }"
          @click.stop="goToSlide(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../api'
import { CURRENT_CONFIG } from '../api/config';
export default {
  name: 'AppCarousel',
  data() {
    return {
      banners: [],
      currentSlide: 0,
      interval: null,
      loading: true,
      error: null,
      BASE_URL: CURRENT_CONFIG.BASE_URL
    }
  },
  mounted() {
    this.fetchBanners()
  },
  beforeUnmount() {
    this.stopCarousel()
  },
  methods: {
    async fetchBanners() {
      this.loading = true
      this.error = null
      try {
        const data = await api.getBanners('head')
        this.banners = data
      } catch (err) {
        this.error = '获取轮播图失败，请稍后重试'
        console.error('获取轮播图失败:', err)
        // 添加默认轮播图作为后备
        this.banners = [
          {
            id: 1,
            imageUrl: 'https://picsum.photos/seed/carousel1/1200/500',
            levelOneTitle: '轮播图加载失败',
            description: '请检查网络连接后重试',
            redirectContentId: null,
            redirectUrl: null
          }
        ]
      } finally {
        this.loading = false
        this.startCarousel()
      }
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.banners.length
    },
    formatText(text) {
      if (!text) return ''
      return text.replace(/\\n/g, '<br>')
    },
    goToSlide(index) {
      this.currentSlide = index
      this.stopCarousel()
      this.startCarousel()
    },
    startCarousel() {
      if (this.banners.length > 0) {
        this.interval = setInterval(() => {
          this.nextSlide()
        }, 5000)
      }
    },
    stopCarousel() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    handleBannerClick(banner) {
      if (banner.redirectContentId) {
        // 内部跳转 - 文章详情
        this.$router.push(`/article/${banner.redirectContentId}`)
      } else if (banner.redirectUrl) {
        // 外部跳转
        window.open(banner.redirectUrl, '_blank')
      }
      // 如果两者都为空，不执行任何操作
    }
  }
}
</script>

<style scoped>
.carousel-container {
  position: relative;
  overflow: hidden;
  min-height: 620px;
  height: 620px;
  width: 100%;
  position: relative;
}

/* 明亮清新蓝调星空背景 */




.carousel-slides-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.carousel-slide.active {
  opacity: 1;
  z-index: 2;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.carousel-content {
  position: relative;
  z-index: 3;
  text-align: center;
  color: white;
  display: inline-block;
  margin: 0 auto;
  padding: 40px;
  border-radius: var(--radius-2xl);
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.carousel-content:hover {
  /*transform: translateY(-4px);*/
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.15);
  border-color: rgba(96, 165, 250, 0.3);
}

.carousel-title {
  font-family: var(--font-family-title);
  font-size: 3.75rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin-bottom: 24px;
  color: white;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
}

.carousel-subtitle {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 24px;
  color: white;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.carousel-description {
  font-size: 1.25rem;
  margin-bottom: 32px;
  color: white;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

/* 按钮样式 */
.btn-primary {
  padding: 12px 32px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, var(--accent), var(--accent-light));
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  animation: breathe 2s ease-in-out infinite;
}

@keyframes breathe {
  0%, 100% {
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  }
  50% {
    box-shadow: 0 8px 25px rgba(37, 99, 235, 0.6);
  }
}

.carousel-indicators {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 10;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.indicator:hover {
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}

.indicator.active {
  background-color: white;
  transform: scale(1.3);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
}

/* 加载状态 */
.carousel-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--bg);
  color: var(--text-primary);
  z-index: 10;
  position: relative;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 3px solid var(--border);
  border-top: 3px solid var(--accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 24px;
  box-shadow: 0 0 20px rgba(96, 165, 250, 0.3);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 错误状态 */
.carousel-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: var(--bg);
  color: var(--text-secondary);
  text-align: center;
  padding: 40px;
  z-index: 10;
  position: relative;
}

.carousel-error p {
  margin-bottom: 24px;
  font-size: 1.1rem;
  background: linear-gradient(135deg, var(--text-secondary), var(--accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .carousel-content {
    padding: 30px;
  }

  .carousel-title {
    font-size: 2.5rem;
  }

  .carousel-subtitle {
    font-size: 1.25rem;
  }

  .carousel-description {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .carousel-content {
    padding: 20px;
  }

  .carousel-title {
    font-size: 1.875rem;
  }

  .carousel-subtitle {
    font-size: 1.1rem;
  }

  .carousel-description {
    font-size: 0.875rem;
  }
}
</style>
